import {ChangeDetectionStrategy, Component, ElementRef, Inject, ViewChild, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogBase} from './dialog-base';
import {DialogData} from './dialog-data';

/**
 * 확인 대화상자 구성 값 구조
 */
export interface ConfirmDialogData extends DialogData {
	message?: string;
	submitText?: string;
	cancelText?: string;
	onOk: Function;
	onCancel?: Function;
}

@Component({
	standalone: false,
	template: `
		<im-dialog-area [dialog]="this"
						[heading]="data?.title"
						[description]="data?.description"
		>
			<p [innerHTML]="data?.message | nl2br | nonKr"></p>
			<ng-template #_foot_>
				<button dot-link color="warn" type="submit" alias="confirmSubmit" (click)="ok()" #primary autofocus>
					<span [innerHTML]="submitText ?? ('' | act:'yes')"></span>
				</button>
				<button dot-link type="button" alias="confirmCancel" (click)="cancel()">
					<span [innerHTML]="cancelText ?? ('' | act:'no')"></span>
				</button>
			</ng-template>
		</im-dialog-area>
	`,
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
/**
 * 확인 대화상자 컴포넌트
 */
export class ConfirmDialogComponent extends DialogBase {
	@ViewChild('primary', {read: ElementRef}) primaryRef!: ElementRef;


	submitText:string;
	cancelText:string;

	constructor(
		protected override dialogRef: MatDialogRef<ConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
	) {
		super(dialogRef);


		this.submitText = data.submitText
		this.cancelText = data.cancelText
		dialogRef.afterOpened().subscribe(() => {
			const {primaryRef} = this;
			primaryRef && primaryRef.nativeElement.focus();
		});

		dialogRef.afterClosed().subscribe(result => {
			if (!result) {
				if (data.onCancel) {
					data.onCancel(dialogRef);
				}
			}
		});
	}

	/**
	 * 확인 실행
	 */
	ok() {
		this.data.onOk(this.dialogRef);
		this.dialogRef.close(true);
	}

	/**
	 * 취소 실행
	 */
	cancel() {
		this.dialogRef.close(false);
	}
}
